import { CardContent } from '@mui/material';
import React from 'react';

export const PaywallCardPrice = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <CardContent sx={{ minHeight: 90 }}>{children}</CardContent>;
};
